<div class="productos__filtrosGeneral">
    <div class="productos__filtroBuscar">
        <em class="fa fa-search iconPlaceholder"></em>
        <input class="productos__inputBuscar input-field" id="buscar" type="text" (keyup)="applyFilter($event)" placeholder="Buscar... " #input>
    </div>
</div>

<!-- COM Tabla Cuatro Cifras  ************************************************************************-->

<div class="productos__listado">
    <div class="mat-elevation-z8">
        <table mat-table aria-describedby="tabla Otros productos" [dataSource]="dataSource" #sort="matSort" matSort>
            <ng-container matColumnDef="empresa">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Empresas</th>
                <td class="productos__centerTd" mat-cell *matCellDef="let row "> {{row?.empresa}} </td>
            </ng-container>

            <ng-container matColumnDef="grupo">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Grupos</th>
                <td class="productos__centerTd" mat-cell *matCellDef="let row "> {{row?.zona}} </td>
            </ng-container>

            <ng-container matColumnDef="recarga">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Recargas</th>
                <td class="productos__centerTd" mat-cell *matCellDef="let row "> {{row?.recargas | currency}} </td>
            </ng-container>

            <ng-container matColumnDef="factura">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Facturas</th>
                <td class="productos__centerTd" mat-cell *matCellDef="let row "> {{row?.facturas | currency}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">No hay datos que coincidan con el filtro o informaci&#243;n "{{input?.value}}"</td>
            </tr>
        </table>

        <mat-paginator #paginador [pageSizeOptions]="[10, 25, 100]" aria-label="Seleccione p&#225;gina"></mat-paginator>
    </div>
</div>